import { useEffect } from "react";
import { Form } from "antd";
import { useAtom } from "jotai";
import { frmPreguntasResolucionProblemaTomaDecisionesAtom, puntajeTotalResolucionProblemaTomaDecisionesAtom } from "../../BandejaEvaluacionStorage";

const usePreguntasResolucionProblemaTomaDecisiones = () => {
	const [puntajeTotal, setPuntajeTotal] = useAtom(puntajeTotalResolucionProblemaTomaDecisionesAtom);
	const [frmPreguntas, setFrmPreguntas] = useAtom(frmPreguntasResolucionProblemaTomaDecisionesAtom);
	const [form] = Form.useForm();

	useEffect(() => {
		if (!frmPreguntas) {
			setFrmPreguntas(form);
		}
	}, []);

	return { frmPreguntas, puntajeTotal, setPuntajeTotal };
};

export default usePreguntasResolucionProblemaTomaDecisiones;
